import {
	CHECK_SPELLING_PROMPT,
	DRAFT_RESPONSE_PROMPT,
	SUMMARIZE_PROMPT,
} from "@productlane/lib/src/writing-quick-actions"
import { IconButton } from "@productlane/ui"
import {
	DropdownMenu,
	DropdownMenuGroup,
	DropdownMenuItem,
} from "@productlane/ui/src/components/internal/dropdown"
import { AiAssistantIcon } from "@productlane/ui/src/icons/project/ai-assistant-icon"
import { CheckSpellingIcon } from "@productlane/ui/src/icons/project/check-spelling-icon"
import { DraftResponseIcon } from "@productlane/ui/src/icons/project/draft-response-icon"
import { SummarizeIcon } from "@productlane/ui/src/icons/project/summarize-icon"

import { useCopilotState } from "@/lib/states/copilot-state"
import { useRole } from "@/lib/useRole"
import { useThreadSidebarState } from "@/screens/app/sidebar"
import { useThreadContext } from "../../../thread-context"
import { useSidebarAiChatState } from "../../right-bar/ai-chat/sidebar-ai-chat-state"

const PROMPTS = [
	{ label: SUMMARIZE_PROMPT, Icon: SummarizeIcon },
	{ label: DRAFT_RESPONSE_PROMPT, Icon: DraftResponseIcon },
	{ label: CHECK_SPELLING_PROMPT, Icon: CheckSpellingIcon },
] as const

export function AiAssistantDropdown() {
	const { role } = useRole()
	const setActiveTab = useThreadSidebarState((s) => s.setActiveTab)
	const openThreadSidebar = useThreadSidebarState((s) => s.open)
	const setPendingPrompt = useSidebarAiChatState((s) => s.setPendingPrompt)
	const requestCopilotFocus = useCopilotState((s) => s.requestFocus)
	const { thread } = useThreadContext()

	if (role === "VIEWER") return null

	const handleSelect = (prompt: string) => {
		setPendingPrompt(prompt)
		setActiveTab("ai-chat")
		requestCopilotFocus({ kind: "thread", threadId: thread.id })
		openThreadSidebar()
	}

	return (
		<DropdownMenu
			trigger={
				<IconButton
					aria-label="AI Assistant"
					variant="ghost"
					className="h-[1.625rem] w-[1.625rem] text-[#7A7E86] hover:text-[#7A7E86] dark:text-secondary dark:hover:text-white [&_svg]:h-4 [&_svg]:w-4"
				>
					<AiAssistantIcon />
				</IconButton>
			}
			contentProps={{ side: "top", align: "start" }}
		>
			<DropdownMenuGroup>
				{PROMPTS.map(({ label, Icon }) => (
					<DropdownMenuItem
						key={label}
						Icon={Icon}
						onClick={() => handleSelect(label)}
					>
						{label}
					</DropdownMenuItem>
				))}
			</DropdownMenuGroup>
		</DropdownMenu>
	)
}
